export const setRoleAction = (role) => {
  return {
    type: "SETROLE",
    payload: role,
  };
};

export const setIsLogin = (value) => {
  return {
    type: "SETLOGIN",
    payload: value,
  };
};
